import SecurityIcon from '@material-ui/icons/Security';
import {
  createFrontendModule,
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { PortalAccessGate } from './AccessContext';

const rootRouteRef = createRouteRef();

const accessControlPage = PageBlueprint.make({
  params: {
    path: '/administracao/acessos',
    routeRef: rootRouteRef,
    loader: () =>
      import('./AccessControlPage').then(module => (
        <module.AccessControlPage />
      )),
  },
});

export const accessControlPlugin = createFrontendPlugin({
  pluginId: 'access-control',
  title: 'Administração de Acessos',
  icon: <SecurityIcon />,
  routes: { root: rootRouteRef },
  extensions: [accessControlPage],
});

const accessGate = AppRootWrapperBlueprint.make({
  params: { component: PortalAccessGate },
});

export const accessControlModule = createFrontendModule({
  pluginId: 'app',
  extensions: [accessGate],
});
